@if (folder) {
  <div class="file-card d-flex flex-column justify-content-between overflow-hidden" (click)="selectFolder()">
    <div class="folder-icon-section bg-lightgrey d-flex align-items-center justify-content-center">
      <app-icon-badge [style]="'documentsFolder'"></app-icon-badge>
    </div>
    <div class="d-flex justify-content-center align-items-center flex-grow-1 px-2 py-1">
      <app-tooltip [text]="folder.name" [width]="'auto'" [height]="'auto'">
        <span class="truncate-text-two-lines text-center overflow-hidden fs-small text-muted">{{ folder.name }}</span>
      </app-tooltip>
    </div>
    <div class="d-flex justify-content-center align-items-end px-2 py-1">
      <app-content [fontSize]="'fs-small'" [fontColor]="'text-secondary'"><b>{{ folder.count }}</b> {{ ('FILES' | translate) }}</app-content>
    </div>
  </div>
}
